import * as e from "react";
import { getServiceFacade as t, createAuthenticatorMachine as r, listenToAuthHub as s } from "@aws-amplify/ui";
import { useSelector as o, useInterpret as n } from "@xstate/react";
import i from "lodash/isEmpty";
import { areArrayValuesEqual as a } from "../../../../helpers/utils.js";

var c = e.createContext({}),
    u = function u(_ref) {
  var t = _ref.children;
  var o = e.useContext(c),
      a = n(r),
      u = e.useMemo(function () {
    return i(o) ? {
      service: a
    } : o;
  }, [o, a]),
      m = u.service;
  return e.useEffect(function () {
    return s(m);
  }, [m]), e.createElement(c.Provider, {
    value: u
  }, t);
},
    m = function m(r) {
  var s = function () {
    var _e$useContext = e.useContext(c),
        t = _e$useContext.service;

    if (!t) throw new Error("Please ensure you wrap your App with `Authenticator.Provider`.\nSee the `useAuthenticator` section on https://ui.docs.amplify.aws/connected-components/authenticator.");
    return t;
  }(),
      n = s.send,
      i = e.useCallback(function (e) {
    return Object.assign({}, t({
      send: n,
      state: e
    }));
  }, [n]),
      u = o(s, function (e) {
    return i(e);
  }, function (e, t) {
    if (!r) return !1;
    var s = r(e),
        o = r(t);
    return a(s, o);
  });

  return Object.assign(Object.assign({}, u), {
    _state: s.getSnapshot(),
    _send: n
  });
};

export { c as AuthenticatorContext, u as Provider, m as useAuthenticator };